import axios from 'axios';
import { clearAuthData } from './auth';

// API Meta fica em outro servidor; configurar em .env com VITE_META_API_URL
const META_API_BASE_URL =
    import.meta.env.VITE_META_API_URL || 'http://localhost:8000/api/v1';

const metaApiClient = axios.create({
    baseURL: META_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

metaApiClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        if (config.headers) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    }
    return config;
});

metaApiClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default metaApiClient;
